import React from "react";
import { HeroStatsProps, backgroundColors } from "../types";
import sortBySortValue from "@/utils/functions/sortBySortValue";
import Image from "next/image";
import { US_NEWS_LOGO } from "../constants";
import useTranslations from "@/i18n/useTranslations";

const DarkLogoNoGap = ({
  courseDetails,
  hasUsNewsLogo = true,
  background = "blue",
  colorBarHexValue,
}: HeroStatsProps) => {
  const t = useTranslations("Common");
  const backgroundColorClass = backgroundColors[background];
  const bottomBorderClass = colorBarHexValue
    ? `!border-[${colorBarHexValue}] !border-b-4`
    : "";
  return (
    <div className="container">
      <div
        style={{ borderBottomColor: `${colorBarHexValue}` }}
        className={`${backgroundColorClass} ${bottomBorderClass} rounded-b-xl grid grid-cols-1 grid-rows-auto md:grid-rows-2 md:grid-cols-4 gap-0 md:gap-4 pb-4`}
      >
        {sortBySortValue(courseDetails || []).map((detail, index) => {
          const firstClass =
            index === 0
              ? "text-center w-full md:col-span-2 row-span-1 md:row-span-2 items-center content-center m-2"
              : "text-center w-full md:col-span-1 content-center m-2";
          const headerClass = index === 0 ? "text-2xl" : "text-1xl";

          const image =
            hasUsNewsLogo && index === 0 ? (
              <Image
                src={US_NEWS_LOGO}
                alt={t("usNewsLogoAlt")}
                width={117}
                height={100}
                className="mt-4 w-[117px] mx-auto justify-center border-none"
                unoptimized
              />
            ) : null;

          return (
            <div
              className={`${firstClass} `}
              key={`${detail.heading}-${index}`}
            >
              {image}
              <p
                className={`${headerClass} my-1 text-primary-foreground font-black font-bold`}
              >
                {detail.heading}
              </p>
              <p className="text-primary-foreground text-sm mb-0">
                {detail.description}
              </p>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default DarkLogoNoGap;
